export default __webpack_public_path__ + "static/media/double_tag.cffc58a1.svg";